import { render } from "./PermessiMenu.vue?vue&type=template&id=07c45a90&scoped=true&ts=true"
import script from "./PermessiMenu.vue?vue&type=script&lang=ts"
export * from "./PermessiMenu.vue?vue&type=script&lang=ts"

import "./PermessiMenu.vue?vue&type=style&index=0&id=07c45a90&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c45a90"]])

export default __exports__